import React from 'react';
import ChatEventCodes from '../../utils/ChatEventCodes.js';

/**
 * Class to define and render buttons that are used in the Kore.ai message templates when required.
 */
export default class Button extends React.Component {
    /**
     * Initializes a new instance of @type {Button}
     * @param {{type: ('postback'|'text'|'url'|'web_url'), displayAsList: Boolean, payload: String, title: String, url?: String, value?: String}} props
     */
    constructor(props) {
        super(props);

        this.sendInput = this.sendInput.bind(this);
    }

    /**
     * Gets the URL value for the button either from the props.url or the props.value data.
     * @returns The URL value or an empty string.
     */
    getHref() {
        if (this.props.url && this.props.url.trim() !== '') {
            return this.props.url;
        } else if (this.props.value && this.props.value.trim() !== '') {
            return this.props.value;
        }
        else {
            return '#';
        }
    }

    /**
     * Emits the event to send the input with the payload of the button.
     */
    sendInput() {
        const data = {
            botPayload: this.props.payload,
            displayMessage: this.props.title
        };
        document.dispatchEvent(new MessageEvent(ChatEventCodes.UserMaskedInput, {data: data}));
    }

    /**
     * Renders the button either as a list item or not driven by displayAsList. This also
     * renders the buttons out if they are either URLs or if they are posting data
     * back to the bot.
     */
    render() {
        if (this.props.type === 'postback' || this.props.type === 'text') {
            if (this.props.displayAsList) {
                return (
                    <li>
                        <button title={`Send ${this.props.title} to the virtual assistant.`} className='button' onClick={this.sendInput}>
                            {this.props.title}
                        </button>
                    </li>
                )
            } else {
                return (
                    <button title={`Send ${this.props.title} to the virtual assistant.`} className='button' onClick={this.sendInput}>
                        {this.props.title}
                    </button>
                )
            }
        }
        else if (this.props.type === 'web_url' || this.props.type === 'url') {
            const href = this.getHref();
            if (this.props.displayAsList) {
                return (
                    <li>
                        <a className='button' href={href} title={`Go to a new page about ${this.props.title}.`}>
                            {this.props.title}
                        </a>
                    </li>
                )
            }
            else {
                return (
                    <a className='button' href={href} title={`Go to a new page about ${this.props.title}.`}>
                        {this.props.title}
                    </a>
                )
            }
        }
        else {
            //Do nothing.
        }
    }
}